<template>
  <main>
    <!-- <carousel /> -->
    <!-- <tabsCenter /> -->
    <div class="main" v-if="loadOver">
      <h1 v-if="meanCenterObj.tabName !== 'honorG'">
        {{ meanCenterObj.tabTitle }}
      </h1>
      <!-- 翱锐简介 -->
      <introductionG v-if="meanCenterObj.tabName == 'introductionG'" />
      <!-- 创始人寄语 -->
      <messageFounderG v-else-if="meanCenterObj.tabName == 'messageFounderG'" />
      <!-- 发展历程 -->
      <devHistoryG v-else-if="meanCenterObj.tabName == 'devHistoryG'" />
      <!-- 荣誉资质 -->
      <honorG v-else-if="meanCenterObj.tabName == 'honorG'" />
      <!-- 企业优势 -->
      <goodnessG v-else-if="meanCenterObj.tabName == 'goodnessG'" />
      <!-- 合作单位 -->
      <CooperationG v-else-if="meanCenterObj.tabName == 'CooperationG'" />
      <!-- 联系我们 -->
      <contactG v-else class="contact" />
    </div>
  </main>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "Go",
  created() {
    this.getCate({
      parent: this.meanCenterObj,
      _child: this.meanCenterObj._child[0],
    })
  },
  computed: { ...mapState(["loadOver"]), ...mapGetters(["meanCenterObj"]) },
  methods: {
    ...mapActions(["getCate"]),
  },
};
</script>

<style scoped lang='less'>
// 中部小导航

@keyframes left {
  to {
    transform: translateX(-315px);
  }
}
.left {
  animation: left 1s;
}
#box {
  width: 5.208vw;
  height: 5.208vw;
  background: sienna;
}
img:hover {
  //   transform: scale(1.5);
}
.container {
  // max-width: 77.7vw;
  // margin: 0 auto;
  // padding: 4.16vw 0 3.125vw;
  > h1 {
    // margin-bottom: 3.1vw;
  }
}
</style>                


// WEBPACK FOOTER //
// src/views/go.vue